import PropTypes from 'prop-types';
import React from 'react';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import { Modal, Button, Form, Input, Radio, Spin, Icon } from 'antd';
import { Select, DatePicker, message, Popconfirm } from 'antd';
import { formatDate, emergencyOption, getDay, eventListener } from '../utils';
import { isDuringDate, checkDate, ctBodyPart } from '../utils';
import { patientSourceOption, checkProv } from '../utils';
import { apis } from '../api/index.js';
const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;
const timeFormat = 'YYYY-MM-DD HH:mm:ss';
const dateFormat = 'YYYY-MM-DD';
class Apply extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    form: PropTypes.object,
    current: PropTypes.object,
    viewType: PropTypes.string,
    history: PropTypes.object,
    applyToCertId: PropTypes.func,
    user: PropTypes.object,
  };

  state = {
    confirmLoading: false,
    status: 0,
    current: {},
    isNightDefault: null,
    positionList: [{ bodyPart: '', checkPosture: null }],
    isLoading: false,
    productionId: '101',
    pageId: '10018',
    idTipVisible: false,
    methods: [],
    bodyPartList: [],
  };
  componentDidUpdate(prevProps) {
    const { visible, current, viewType } = this.props;
    if (prevProps.visible !== visible && visible) {
      const info = this.props.user;
      const { certId, nickName } = info;
      if (!certId || nickName.length > 4 || !nickName)
        this.setState({ idTipVisible: true });

      this.setState(
        {
          current,
          positionList: [{ bodyPart: '', checkPosture: null }],
        },
        () => {
          this.getBodyPartList();

          if (viewType === 'detail') this.getApplicationInfo();
          else this.getApply();
        }
      );

      this.props.form.resetFields();
      this.setNightDefault();
      this.getCheckMethod();
    }
  }

  getBodyPartList = async type => {
    const { modality } = this.state.current;
    if (!type) type = modality;

    const res = await ctBodyPart(type);
    this.setState({ bodyPartList: res });
  };
  getCheckMethod = type => {
    const { modality } = this.state.current;
    if (!type) type = modality;

    apis.ctCheckMethod(type).then(res => {
      this.setState({ methods: res.code === '0' ? res.data : [] });
    });
  };

  //是否夜间急诊
  setNightDefault = () => {
    const currentTime = new Date().getHours();
    let [start, end] = [0, 1];
    if (currentTime >= 0 && currentTime <= 7) [start, end] = [-1, 0];

    let [startDate, endDate] = [
      getDay(start, ' 17:0:0'),
      getDay(end, ' 8:0:0'),
    ];
    const isNight = isDuringDate(startDate, endDate);
    let isNightDefault = isNight ? 2 : null;
    this.setState({ isNightDefault });
    return isNightDefault;
  };
  //查看申请单详情
  getApplicationInfo = () => {
    const id = this.state.current.applicationId;
    apis.ctApplicationInfo(id).then(res => {
      if (res.code === '0') {
        let { data } = res;
        this.setState({ current: data, positionList: data.parts });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //发起申请
  getApply = () => {
    const id = this.state.current.diagId;
    apis.ctApply(id).then(res => {
      if (res.code === '0') {
        this.setState({ current: res.data, confirmLoading: false });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  submitApply = (type, values) => {
    const info = this.props.user;
    const { certId, nickName } = info;
    if (!certId || nickName.length > 4 || !nickName) {
      this.setState({ idTipVisible: true });
    }
    this.setState({ confirmLoading: true });
    //保存评价内容
    const { current, positionList } = this.state;
    let { birthday, studyDateTime } = values;
    birthday = birthday ? formatDate(birthday, dateFormat) : undefined;
    studyDateTime = formatDate(studyDateTime, timeFormat);
    let post = {
      ...values,
      parts: positionList,
      diagId: current.id,
      birthday: birthday,
      studyDateTime,
    };
    let url = '';
    this.setState({ isLoading: true });
    if (type === 'new') {
      url = apis.ctSaveApplication(post);
    } else if (type === 'update') {
      post = { ...post, id: current.id, diagId: current.diagId };
      url = apis.ctUpdateApplication(post);
    }
    url.then(res => {
      this.setState({ confirmLoading: false, isLoading: false });
      if (res.code === '0') {
        message.success('申请成功');
        this.handleCancel(true);
      } else {
        message.error(res.message);
        this.handleCancel(false);

        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  handleOk = (type, e) => {
    e.preventDefault();
    const [isNightDefault, _this] = [this.setNightDefault(), this];

    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (isNightDefault === 2 && values.emergencyFlag !== 2) {
          confirm({
            title: '提示',
            content:
              '急诊类型修改为夜间急诊吗？否则夜间报告无医生审核，可能导致报告无法下发',
            okText: '确认修改',
            okType: 'danger',
            cancelText: '立即申请',
            centered: true,
            onOk() {
              //点击确认修改，把急诊类型改成夜间急诊再提交
              values.emergencyFlag = 2;
              _this.submitApply(type, values);
            },
            onCancel() {
              //点击立即申请，直接提交
              _this.submitApply(type, values);
            },
          });
        } else this.submitApply(type, values);
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = (changed, type) => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0004' };
    let elementIdMap = { cancel: 'ns-002', close: 'ns-001' };

    type &&
      eventListener({ ...eventData, elementId: elementIdMap[type] }, true);

    this.props.onCancel(changed);
  };

  setPositionList = (index, value) => {
    let { positionList } = this.state;
    positionList[index].bodyPart = value;
    positionList[index].checkPosture = null;
    this.props.form.setFieldsValue({ [`position_${index}`]: null });
  };

  handlePostureChange = (index, value) => {
    const { positionList } = this.state;
    positionList[index].checkPosture = value;
    this.setState({ positionList });
    this.setApplyProject();
  };

  setApplyProject = () => {
    const { positionList } = this.state;
    const list = positionList.map(l => `${l.bodyPart}-${l.checkPosture}`);
    this.props.form.setFieldsValue({ applicationItem: list.join('，') });
  };

  changePatientSource = value => {
    let { current } = this.state;
    const des = value === 2 ? '体检' : '';
    current = { ...current, description: des, medicalHistory: des };
    this.setState({ current });
  };

  addPart = () => {
    const { positionList } = this.state;
    positionList.push({ bodyPart: '', checkPosture: null });
    this.setState({ positionList });
  };

  delPart = index => {
    const { positionList } = this.state;
    positionList.splice(index, 1);
    this.setState({ positionList });
    this.setApplyProject();
  };

  handleReApply = () => {
    message.warning('医生正在为您处理，处理完后才可以重新申请。');
  };

  handleIDType = value => {
    this.setState({ idType: value });
  };
  IDNoValidator = (rule, value, callback) => {
    const { idType } = this.state;
    //01:居民身份证
    //02:居民户口簿
    //03:护照
    //04:军官证
    //05:驾驶证
    //06:港澳居民来往内地通行证
    //07:台湾居民来往内地通行证
    //08:出生医学证明
    //09:其他法定有效证件
    let [reg, name] = ['', ''];
    if (['01', '05'].includes(idType)) {
      name = '居民身份证';
      reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    } else if (idType === '02') {
      [name, reg] = ['居民户口簿', /\d{9}/];
    } else if (idType === '03') {
      [name, reg] = ['护照', /^([a-zA-z]|[0-9]){9}$/];
    } else if (idType === '04') {
      name = '军官证';
      reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;
    } else if (idType === '06') {
      name = '港澳居民来往内地通行证';
      reg = /^[HMhm]{1}([0-9]{10}|[0-9]{8})$/;
    } else if (idType === '07') {
      name = '台湾居民来往内地通行证';
      reg = /^\\d{8}|^[a-zA-Z0-9]{10}|^\\d{18}$/;
    }
    if (reg) {
      if (!value) callback(`请输入${name}号码`);
      else if (!reg.test(value)) callback(`${name}号码不合规`);
      else if (['01', '05'].includes(idType)) {
        const province = value.substring(0, 2);
        if (!checkProv(province)) callback(`${name}号码不合规`);

        const birthday = value.substring(6, 14);
        if (!checkDate(birthday)) callback(`${name}号码不合规`);

        let sevenTeenIndex = [
          7,
          9,
          10,
          5,
          8,
          4,
          2,
          1,
          6,
          3,
          7,
          9,
          10,
          5,
          8,
          4,
          2,
        ];

        let front17 = value.slice(0, 17);
        let last1 = value.slice(17, 18);
        last1 = isNaN(parseInt(last1)) ? last1.toLowerCase() : parseInt(last1);

        let remainder = 0;
        for (let i = 0; i < 17; i++) {
          remainder += parseInt(front17.charAt(i)) * sevenTeenIndex[i];
        }
        let remainderKeyArr = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
        let remainderKey = remainderKeyArr[remainder % 11];
        remainderKey = typeof remainderKey === 'string' ? 'x' : remainderKey;
        if (remainderKey !== last1) callback(`${name}号码不合规`);

        callback();

        const year = value.substring(6, 10);
        const month = value.substring(10, 12);
        const day = value.substring(12, 14);

        const { current } = this.state;
        this.setState({
          current: {
            ...current,
            birthday: moment(new Date(`${year}-${month}-${day}`)),
          },
        });
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
  applyToCertId = () => {
    this.setState({ idTipVisible: false });
    this.props.applyToCertId(true);
  };
  modalityChange = value => {
    this.getBodyPartList(value);
    this.getCheckMethod(value);
    this.setState({
      positionList: [{ bodyPart: '', checkPosture: null }],
    });
    this.props.form.setFieldsValue({ applicationItem: '' });
  };
  render() {
    let { confirmLoading, current } = this.state;
    let { isNightDefault, positionList, isLoading } = this.state;
    const { idTipVisible, methods, bodyPartList } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { viewType } = this.props;

    const userInfo = this.props.user;
    const disabled =
      viewType === 'detail' && current.createUser !== userInfo.id;

    const roleInfo = (userInfo.operationAuths || '').split(',');
    const isAnonymity = roleInfo.includes('S');
    const api = window.store.getState().api;
    const IDTypeDict = api.current.IDTypeDict || [];
    const cardTypeDict = api.current.cardTypeDict || [];
    const nationalDict = api.current.nationalDict || [];
    const doingArray = [11, 21, 40];
    const buttons = [
      <Button
        key="cancel"
        onClick={() => this.handleCancel(false, 'cancel')}
        type="default"
        className="btn-cancel"
      >
        取消
      </Button>,
    ];
    const sexOptions = [
      { label: '男', value: 'M' },
      { label: '女', value: 'F' },
      { label: '未知', value: '' },
    ];
    if (viewType === 'detail') {
      if (current.createUser === userInfo.id) {
        buttons.push(
          <>
            {doingArray.indexOf(current.state) >= 0 ? ( //有其他医生正在处理此报告，不可以重新申请
              <Button
                type="primary"
                loading={confirmLoading}
                onClick={this.handleReApply}
                className="btn-ok"
                key="redo"
              >
                重新申请
              </Button>
            ) : (
              <Popconfirm
                placement="topRight"
                title="报告还没处理完成，确定要重新申请吗？"
                onConfirm={e => this.handleOk('update', e)}
                okText="确定"
                cancelText="取消"
                key="confirm"
              >
                <Button
                  className="btn-ok"
                  type="primary"
                  loading={confirmLoading}
                >
                  重新申请
                </Button>
              </Popconfirm>
            )}
          </>
        );
      }
    } else {
      buttons.push(
        <Button
          type="primary"
          key="apply"
          loading={confirmLoading}
          onClick={e => this.handleOk('new', e)}
          className="btn-ok"
        >
          申请
        </Button>
      );
    }
    return (
      <>
        {isLoading && (
          <div className="spin-box-bg">
            <Spin indicator={<Icon type="loading" spin />} />
          </div>
        )}
        <Modal
          title="患者信息"
          visible={this.props.visible}
          width="100%"
          height="100%"
          className="group-manager group-manager-apply"
          onCancel={() => this.handleCancel(false, 'close')}
          footer={buttons}
          centered={true}
          keyboard={false}
          maskClosable={false}
        >
          <div className="report-list-modal">
            {/* 弹出框 */}
            <Form className="apply-form">
              <div className="type-title">患者信息录入</div>
              <Form.Item label="患者姓名" colon={false} className="width1">
                {getFieldDecorator('patName', {
                  rules: [{ required: true, message: '请填写患者姓名' }],
                  initialValue: current.patName,
                })(<Input placeholder="请填写患者姓名" disabled={disabled} />)}
              </Form.Item>
              {isAnonymity && (
                <Form.Item label=" " colon={false} className="anonymity width1">
                  {getFieldDecorator('patName1', {
                    initialValue: '***',
                  })(<Input disabled={true} />)}
                </Form.Item>
              )}
              <Form.Item label="患者年龄" colon={false} className="width1">
                {getFieldDecorator('patAge', {
                  rules: [{ required: true, message: '请填写患者年龄' }],
                  initialValue: current.patAge,
                })(<Input placeholder="请填写患者年龄" disabled={disabled} />)}
              </Form.Item>
              {isAnonymity && (
                <Form.Item label=" " colon={false} className="anonymity width1">
                  {getFieldDecorator('patAge1', {
                    initialValue: '***',
                  })(<Input disabled={true} />)}
                </Form.Item>
              )}
              <Form.Item label="患者性别" colon={false} className="width1">
                {getFieldDecorator('patSex', {
                  rules: [{ required: true, message: '请选择患者性别' }],
                  initialValue: current.patSex,
                })(
                  <Radio.Group disabled={disabled}>
                    {sexOptions.map((item, index) => (
                      <Radio key={index} value={item.value}>
                        {item.label}
                      </Radio>
                    ))}
                  </Radio.Group>
                )}
              </Form.Item>
              {isAnonymity && (
                <Form.Item label=" " colon={false} className="anonymity width1">
                  {getFieldDecorator('patSex1', {})(
                    <Radio.Group disabled={true}>
                      {sexOptions.map((item, index) => (
                        <Radio key={index} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                    </Radio.Group>
                  )}
                </Form.Item>
              )}
              <Form.Item label="证件类型" colon={false} className="width1">
                {getFieldDecorator('idType', {
                  rules: [{ required: true, message: '请选择证件类型' }],
                  initialValue: current.idType || '',
                })(
                  <Select
                    placeholder="请选择证件类型"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    onChange={this.handleIDType}
                  >
                    {IDTypeDict.map((item, index) => (
                      <Option key={index} value={item.code}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="证件号码" colon={false} className="width1">
                {getFieldDecorator('idNumber', {
                  rules: [
                    { validator: this.IDNoValidator },
                    { required: true, message: ' ' },
                  ],
                  initialValue: current.idNumber || '',
                })(
                  <Input
                    placeholder="请输入证件号码"
                    disabled={disabled}
                    maxLength={18}
                  />
                )}
              </Form.Item>
              <Form.Item label="出生年月" colon={false} className="width1">
                {getFieldDecorator('birthday', {
                  initialValue: current.birthday
                    ? moment(current.birthday, dateFormat)
                    : null,
                  value: current.birthday
                    ? moment(current.birthday, dateFormat)
                    : null,
                  rules: [
                    {
                      required: true,
                      message: '请选择出生年月',
                      type: 'object',
                    },
                  ],
                })(
                  <DatePicker
                    locale={zh_CN}
                    format={dateFormat}
                    placeholder="请选择出生年月"
                    disabled={disabled}
                    style={{ width: '100%' }}
                    onChange={value => {
                      const { current } = this.state;
                      this.setState({
                        current: { ...current, birthday: value },
                      });
                    }}
                  />
                )}
              </Form.Item>
              <Form.Item label="民族" colon={false} className="width1">
                {getFieldDecorator('national', {
                  initialValue: current.national || '',
                  rules: [{ required: true, message: '请选择民族' }],
                })(
                  <Select
                    placeholder="请选择民族"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {nationalDict.map((item, index) => (
                      <Option key={index} value={item.code}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="详细地址" colon={false} className="width2">
                {getFieldDecorator('address', {
                  initialValue: current.address || '',
                })(<Input placeholder="请输入详细地址" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="联系方式" colon={false} className="width1">
                {getFieldDecorator('mobileNumber', {
                  initialValue: current.mobileNumber || '',
                })(
                  <Input
                    placeholder="请输入联系方式"
                    disabled={disabled}
                    maxLength={11}
                  />
                )}
              </Form.Item>
              <Form.Item label="监护人身份证" colon={false} className="width1">
                {getFieldDecorator('guardianCertId', {
                  initialValue: current.guardianCertId || '',
                })(
                  <Input
                    placeholder="请输入监护人身份证"
                    disabled={disabled}
                    maxLength={18}
                  />
                )}
              </Form.Item>
              <Form.Item label="监护人姓名" colon={false} className="width1">
                {getFieldDecorator('guardianName', {
                  initialValue: current.guardianName || '',
                })(
                  <Input
                    placeholder="请输入监护人姓名"
                    disabled={disabled}
                    maxLength={50}
                  />
                )}
              </Form.Item>
              <Form.Item label="患者卡类型" colon={false} className="width1">
                {getFieldDecorator('cardType', {
                  initialValue: current.cardType || '',
                })(
                  <Select
                    placeholder="请选择患者卡类型"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {cardTypeDict.map((item, index) => (
                      <Option key={index} value={item.code}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="患者卡号" colon={false} className="width1">
                {getFieldDecorator('cardNo', {
                  initialValue: current.cardNo || '',
                })(<Input placeholder="请输入患者卡号" disabled={disabled} />)}
              </Form.Item>
              <div className="type-title">检查信息录入</div>
              <Form.Item label="检查类型" colon={false} className="width1">
                {getFieldDecorator('modality', {
                  rules: [{ required: true, message: '请选择检查类型' }],
                  initialValue: current.modality || 'CT',
                })(
                  <Select
                    placeholder="请选择检查类型"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    onChange={this.modalityChange}
                  >
                    {['CT', 'MR'].map((item, index) => (
                      <Option key={index} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="患者编号" colon={false} className="width1">
                {getFieldDecorator('patId', {
                  initialValue: current.patId || null,
                })(<Input placeholder="请填写患者编号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="检查编号" colon={false} className="width1">
                {getFieldDecorator('accessionNumber', {
                  initialValue: current.accessionNumber || null,
                })(<Input placeholder="请填写检查编号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="住院号" colon={false} className="width1">
                {getFieldDecorator('hospitalizedNumber', {
                  initialValue: current.hospitalizedNumber || null,
                })(<Input placeholder="请填写住院号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="床号" colon={false} className="width1">
                {getFieldDecorator('bedNum', {
                  initialValue: current.bedNum || null,
                })(<Input placeholder="请填写床号" disabled={disabled} />)}
              </Form.Item>
              <Form.Item label="门诊号" colon={false} className="width1">
                {getFieldDecorator('outpatientNum', {
                  initialValue: current.outpatientNum || null,
                })(<Input placeholder="请填写床号" disabled={disabled} />)}
              </Form.Item>

              <Form.Item label="急诊" colon={false} className="width1">
                {getFieldDecorator('emergencyFlag', {
                  rules: [{ required: true, message: '请选择是否急诊' }],
                  initialValue:
                    current.emergencyFlag === undefined
                      ? isNightDefault
                      : current.emergencyFlag,
                })(
                  <Select
                    placeholder="是否急诊"
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {emergencyOption()}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="检查时间" colon={false} className="width1">
                {getFieldDecorator('studyDateTime', {
                  initialValue: current.studyDateTime
                    ? moment(current.studyDateTime, timeFormat)
                    : null,
                })(
                  <DatePicker
                    locale={zh_CN}
                    format={timeFormat}
                    showTime
                    placeholder="请选择检查时间"
                    disabled={disabled}
                  />
                )}
              </Form.Item>
              <Form.Item label="患者来源" colon={false} className="width1">
                {getFieldDecorator('patientSource', {
                  initialValue: current.patientSource,
                  rules: [{ required: true, message: '请选择患者来源' }],
                })(
                  <Select
                    placeholder="请选择患者来源"
                    disabled={disabled}
                    onChange={this.changePatientSource}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {patientSourceOption()}
                  </Select>
                )}
              </Form.Item>
              {positionList.map((item, index) => (
                <div key={index}>
                  <Form.Item label="检查部位" className="width1">
                    {getFieldDecorator(`part_${index}`, {
                      rules: [{ required: true, message: '请选择检查部位' }],
                      initialValue: item.bodyPart || null,
                    })(
                      <Select
                        placeholder="选择检查部位"
                        showSearch
                        disabled={disabled}
                        onChange={value => this.setPositionList(index, value)}
                        getPopupContainer={triggerNode =>
                          triggerNode.parentNode
                        }
                      >
                        {bodyPartList.map((item, index) => (
                          <Option value={item.code} key={index}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                  <Form.Item label="检查方法" className="width1">
                    {getFieldDecorator(`position_${index}`, {
                      rules: [{ required: true, message: '请选择检查体位' }],
                      initialValue: item.checkPosture || null,
                    })(
                      <Select
                        placeholder="选择检查体位"
                        disabled={disabled}
                        onChange={value =>
                          this.handlePostureChange(index, value)
                        }
                        getPopupContainer={triggerNode =>
                          triggerNode.parentNode
                        }
                      >
                        {(methods || []).map((item, index) => (
                          <Option value={item.code} key={index}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                  <div className="width1">
                    <Button
                      icon="minus-circle"
                      type="danger"
                      style={{ marginTop: '2px' }}
                      disabled={positionList.length === 1 || disabled}
                      onClick={() => this.delPart(index)}
                    >
                      删除部位
                    </Button>
                    <Button
                      icon="plus-circle"
                      type="primary"
                      disabled={disabled}
                      style={{ marginTop: '3px', marginLeft: '10px' }}
                      onClick={this.addPart}
                    >
                      添加部位
                    </Button>
                  </div>
                </div>
              ))}
              <Form.Item label="申请项目" colon={false} className="width3">
                {getFieldDecorator('applicationItem', {
                  initialValue: current.applicationItem || null,
                  rules: [{ required: true, message: '申请项目不能为空' }],
                })(<Input placeholder="请填写申请项目" disabled={true} />)}
              </Form.Item>
              <Form.Item label="病情描述" colon={false} className="width3">
                {getFieldDecorator('description', {
                  rules: [{ required: true, message: '请填写病情描述' }],
                  initialValue: current.description || null,
                })(
                  <TextArea
                    placeholder="请填写病情描述"
                    autosize={false}
                    disabled={disabled}
                  />
                )}
              </Form.Item>
              <Form.Item label="既往病史" colon={false} className="width3">
                {getFieldDecorator('medicalHistory', {
                  rules: [{ required: true, message: '请填写既往病史' }],
                  initialValue: current.medicalHistory || null,
                })(
                  <TextArea
                    placeholder="请填写既往病史"
                    autosize={false}
                    disabled={disabled}
                  />
                )}
              </Form.Item>
              <Form.Item label="患者病历" colon={false} className="width3">
                {getFieldDecorator('thisemr', {
                  initialValue: current.thisemr || null,
                })(
                  <TextArea
                    placeholder="请填写患者病历"
                    autosize={false}
                    disabled={disabled}
                    maxLength={1000}
                  />
                )}
              </Form.Item>
              <Form.Item label="初步诊断" colon={false} className="width3">
                {getFieldDecorator('diagnosis', {
                  initialValue: current.diagnosis || null,
                })(
                  <TextArea
                    placeholder="请填写初步诊断内容"
                    autosize={false}
                    disabled={disabled}
                    maxLength={1000}
                  />
                )}
              </Form.Item>
              <Form.Item label="会诊目的" colon={false} className="width3">
                {getFieldDecorator('purpose', {
                  initialValue: current.purpose || null,
                })(
                  <TextArea
                    placeholder="请填写会诊目的"
                    autosize={false}
                    disabled={disabled}
                    maxLength={1000}
                  />
                )}
              </Form.Item>
              {current.state > 1 && (
                <div>
                  <Form.Item label="申请医生" colon={false} className="width3">
                    <span>{current.createUserName}</span>
                  </Form.Item>
                  <Form.Item label="申请时间" colon={false} className="width3">
                    <span>{current.createTime}</span>
                  </Form.Item>
                </div>
              )}
            </Form>
          </div>
        </Modal>

        {idTipVisible && (
          <div className="certid-tip">
            <div className="content">
              <p>
                根据互联网医院监管平台要求，请在申请诊断前先去完善申请人姓名和补充身份证号，提交后即可进行诊断申请。
              </p>
              <p>
                <Button type="primary" onClick={this.applyToCertId}>
                  完善信息
                </Button>
              </p>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Form.create()(Apply);
